import Smedetoften from './Smedetoften';

export default Smedetoften;